import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    field_required: {
      id: 'field_required',
      defaultMessage: "Field required",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/Input/Messages.js